import { render, staticRenderFns } from "./FicBicTag.vue?vue&type=template&id=5dc13a97&"
import script from "./FicBicTag.vue?vue&type=script&lang=js&"
export * from "./FicBicTag.vue?vue&type=script&lang=js&"
import style0 from "./FicBicTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports